$(document).ready(function () {
    let search_active = false;
    let $search_form = $('.search-bar__new');
    let $cart_icon_mobile = $('.site-nav--mobile .js-drawer-open-right');
    let $search_icon_desktop = $('.search-icon--desktop');
    let $cross_icon_desktop = $('.cross-icon--desktop');
    let $search_form_desktop = $('.search-bar__desktop .search-bar__new');
    let search_is_mobile = $(window).width() <= 768;

    (function () {
        $('.footer-newsletter').hide();
        $('#opt-in-form').slideDown();
    })();

    handleMolinChatWidget()

    $('.search-icon').on('click', function () {
        if (!search_active) {
            $search_form_desktop.removeClass('search-bar--closed');
            $search_form_desktop.addClass('search-bar--opened');
            $search_form_desktop.focus();
            $search_icon_desktop.hide();
            $cross_icon_desktop.show();
            $cart_icon_mobile.css("pointer-events", "none").hide();
            setTimeout(function () {
                toggleSearchBarClear()
            }, 400);
            search_active = true;
            let search_width = $(window).width() <= 768 ? '150%' : '100%'
            $search_form_desktop.stop().animate({width: search_width, marginLeft: '0'}, 0)
                .promise()
                .then(function () {
                });
        } else {
            $search_form_desktop.removeClass('search-bar--opened');
            $('.search-bar__desktop').removeClass('input--filled');
            $search_form_desktop.stop().animate({width: '70px', marginLeft: '95%'}, 0, function () {
            });
            $search_icon_desktop.show();
            $cross_icon_desktop.hide();
            $('.search-bar-clear').hide();
            $cart_icon_mobile.show();
            setTimeout(function () {
                $cart_icon_mobile.css("pointer-events", "auto");
                $search_form_desktop.addClass('search-bar--closed')
            }, 330)
            search_active = false;
        }
    });

    $(window).on('resize orientationchange', function () {
        let current_search_is_mobile = $(window).width() <= 768;

        if (current_search_is_mobile === search_is_mobile) {
            return;
        }

        search_is_mobile = current_search_is_mobile;
        search_active = false;
        $search_form.val('');
        $search_form_desktop.removeClass('search-bar--opened').addClass('search-bar--closed');
        $search_form_desktop.stop().css({width: '70px', marginLeft: '95%'});
        $('.search-bar__desktop, .search-bar__mobile').removeClass('input--filled');
        $search_icon_desktop.show();
        $cross_icon_desktop.hide();
        $('.search-bar-clear').hide();
        $cart_icon_mobile.css("pointer-events", "auto").show();
    });

    function toggleSearchBarClear() {
        $search_form.each(function () {
            let $current_search_form = $(this);
            let search_bar_opened = $current_search_form.hasClass('search-bar--opened') || $current_search_form.closest('.search-bar__mobile').length;
            let $current_search_bar_clear = $current_search_form.siblings('.search-bar-clear');

            if ($current_search_form.val().length > 0 && search_bar_opened) {
                $current_search_bar_clear.show();
            } else {
                $current_search_bar_clear.hide();
            }
        });
    }

    $search_form.on('input', function () {
        toggleSearchBarClear();
    });

    toggleSearchBarClear();

    let profile_active = false;
    /*  $('body').click(function (e) {
          if ($(e.target).parent().attr('id') !== $('#profile-icon').attr('id') && profile_active === true) {
              profile_active = false;
              $('.shape-container').fadeOut();
          }
      });
  */
    $('#profile-icon').on('click', function () {
        if (!profile_active) {
            profile_active = true;
            $('.shape-container').fadeIn();
        } else {
            profile_active = false;
            $('.shape-container').fadeOut();
        }
    })

    $('input').each(function () {
        if ($(this).val()) {
            $(this).addClass('input--filled');
        }
    });

    $('.footer-navigation span').on('click touch', function () {
        if ($(window).width() <= 480) {
            $(this).next('.footer-navigation__block').slideToggle();
            $(this).children("img").toggleClass('up').toggleClass('down');
        }
    });

    $('.footer-newsletter').on('click', function () {
        $(this).hide();
        $('#opt-in-form').slideDown();
    });

    $('.cancel-btn span').on('click', function () {
        $('#opt-in-form').hide();
        $('.footer-newsletter').show();
    });

    $(document).on('input', '.search-bar__mobile input', function () {
        if ($(this).val()) {
            $(this).addClass('input--filled');
            $('.search-bar__mobile').addClass('input--filled');
        } else {
            $(this).removeClass('input--filled');
            $('.search-bar__mobile').removeClass('input--filled');
        }

        $(this).removeClass('error');
    });

    $(document).on('input', '.search-bar__desktop input', function () {
        if ($(this).val()) {
            $(this).addClass('input--filled');
            $('.search-bar__desktop').addClass('input--filled');
        } else {
            $(this).removeClass('input--filled');
            $('.search-bar__desktop').removeClass('input--filled');
        }

        $(this).removeClass('error');
    });


    if (typeof has_variants !== 'undefined' && has_variants === true) {
        if ($('#single-product').length && $('.minict_wrapper span').length) {
            $('.minict_wrapper span').attr('data-placeholder', $('.minict_wrapper span').html().trim());
            $('.minict_wrapper span').attr('contenteditable', false);
        }
    }

    if (typeof has_variants !== 'undefined' && !has_variants) {
        $('#productSelect').parent().hide();
    }

    $('.product-single__thumbnail--img').on('click touch', function () {
        $('.product-single__thumbnail--overlay').remove();
        $(this).closest('.product-single__thumbnail--container').append('<div class="product-single__thumbnail--overlay"></div>');
    });

    var timeout;


    function hide() {
        timeout = setTimeout(function () {
            $(".cart__hover").fadeOut();
        }, 500);
    }

    $(".site-header-cart-button").mouseover(function () {
        clearTimeout(timeout);

    }).mouseout(hide);

    if (typeof judgeme_enabled !== 'undefined' && judgeme_enabled === true) {
        let judgme_ready = false;

        $(document).ajaxStop(function () {

            if (judgme_ready === false) {
                let judgme_button = $(".jdgm-widget-actions-wrapper");

                if(judgme_button.length > 1){
                  judgme_button[0].remove();
                }

                let judgme_histogram = $(".jdgm-histogram");
                let judgme_filter_select = $('.jdgm-rev-widg__sort-wrapper');
                let judgme_form = $('.jdgm-form-wrapper');

                let exclamation_mark_src = "//baotechusa.com/cdn/shop/t/7/assets/info.svg?v=167002244631414205691601624768";

                judgme_button.before(judgme_histogram);
                judgme_form.after(judgme_filter_select);

                let info_box_has_a_question = 'Translation missing: de.biotech.judgeme.info_box_have_a_question';
                let info_box_text = 'Translation missing: de.biotech.judgeme.info_box_text';
                let translation_missing_error = 'translation missing';
                let translations_missing = [info_box_has_a_question, info_box_text].some(t =>
                    !t || t.trim() === "" || t.toLowerCase().includes(translation_missing_error)
                );
                let $tooltip_content = '';

                if (!translations_missing) {
                    $tooltip_content = '<div class="judgme-form-tooltip-content"><div class="exl"><img src="' + exclamation_mark_src + '"></div><div class="judgme-form-tooltip-content-inner"><span class="question">' + info_box_has_a_question + '</span><br><span class="text">' + info_box_text + '</span><br></div></div>';
                }

                let $extension_div = '<div class="judgme-form-tooltip"><span class="judgme-form-tooltip-title">Bitte füllen Sie die Felder unten aus</span>' + $tooltip_content + '</div>'
                let $default_sort_option = '<option disabled selected>Sortieren</option>';

                judgme_form.prepend($extension_div);
                judgme_filter_select.find('select.jdgm-sort-dropdown').prepend($default_sort_option);

                $.each($('.jdgm-rev'), function () {
                    moveJudgmeAction($(this));
                    removeEmptyReply($(this));
                    changeRatingPosition($(this));
                })

                renderPaginationArrows();
                renderVisibleReviewCount();

                judgme_ready = true;

                $(document).trigger('judgeme-render');
            }
        });
    }

    $(document).on('input', '.js-qty__num', RefreshSmallCartPriceAndQty);

    $(document).on('click','.js-qty__adjust--plus', RefreshSmallCartPriceAndQty);

    $(document).on('click','.js-qty__adjust--minus', RefreshSmallCartPriceAndQty);


    $('#nav-drawer-overlay').on('click touch', function () {
        $('#NavDrawer .js-drawer-close').trigger('touchend');
    });

    // Főoldal tab aktiválás footer linkre kattintva
    $('.template-index .footer-navigation a[href^="/#"]').on('click touch', function (e) {
        e.preventDefault();
        scrollToTabs();
        activateTab($(this).attr('href'));
    });

    // Főoldal tab aktiválás másik oldalról érkezve
    if ($('body').hasClass('template-index')) {
        var href = window.location.hash;
        var normalizedHref = href;
        if (normalizedHref && normalizedHref.charAt(0) !== '#') {
            normalizedHref = '#' + normalizedHref;
        }

        var is_tab_href = (
            $('#home-tab-first button.home-tab[data-target="' + normalizedHref + '"]').length > 0 ||
            $('#home-tab-first button.home-tab[data-target="' + normalizedHref.replace('#', '') + '"]').length > 0
        );

        if (is_tab_href) {
            scrollToTabs();

            setTimeout(function () {
                activateTab(href);
            }, 100);
        }
    }

    shrinkMobilePagination(pagination_config.collection);

    $(document).on('ais-render', function () {
        shrinkMobilePagination(pagination_config.result_page);
    });

    $(document).on('judgeme-render', function () {
        shrinkMobilePagination(pagination_config.judgeme);
    });

    var mega_menu_lis = $('.site-nav li').filter(function() {
        return $(this).children().hasClass('mega-menu__link');
    });

    mega_menu_lis.on('mouseenter', function (e) {
        e.preventDefault();

        if ($('.search-bar__new.search-bar--opened').length) {
            closeMegaMenu();
            return;
        }

        window.dataLayer.push({
            'event':'megamenu-open',
        });

        if ($(this).children('a').hasClass('remodal--closed')) {
            openMegaMenu($(this).children('a'));
        }
    }).on('mouseleave', closeMegaMenu);
    $(document).on('click', '.webshop--overlay', closeMegaMenu);
    $('.webshop--remodal').on('mouseleave', closeMegaMenu);

    function openMegaMenu(parent) {
        const webShopOverlay = $('.webshop--overlay');
        var dataIndex = parent.attr('data-index');
        window.openedMegaMenuIndex = dataIndex;
        $('.webshop--remodal[data-index]').addClass('closed');
        webShopOverlay.hide();
        $('.site-nav .mega-menu__link').removeClass('remodal--opened').addClass('remodal--closed');

        let relatedModal = $(`.webshop--remodal[data-index="${dataIndex}"]`);
        if (relatedModal.length) {
            relatedModal.removeClass('closed');
            parent.addClass('remodal--opened').removeClass('remodal--closed');
            webShopOverlay.show();
        }
    }

    function closeMegaMenu() {
        var dataIndex = window.openedMegaMenuIndex;
        setTimeout(function () {
            const $parentLi = $(`.mega-menu__link[data-index="${dataIndex}"]`).closest('li');

            if (!$('.webshop--remodal:hover').length && !$parentLi.is(":hover")) {
                $(`.webshop--remodal[data-index="${dataIndex}"]`).addClass('closed');
                $(`.mega-menu__link[data-index="${dataIndex}"]`).removeClass('remodal--opened').addClass('remodal--closed');

                const allClosed = $('.webshop--remodal').length === $('.webshop--remodal.closed').length;
                if (allClosed) {
                    $('.webshop--overlay').hide();
                }
            }
        }, 200);
    }

    $(function () {
        if (window.mpl_administrative_cost) {
            var exist_administrative_cost_item = false;

            $.getJSON('/cart.js', function (cart) {
                $.each(cart.items, function (index, cartItem) {
                    if (mpl_administrative_cost_varriant_id == cartItem.variant_id) {
                        exist_administrative_cost_item = true;
                    }
                });
            }).success(function () {
                if (exist_administrative_cost_item) {
                    $.ajax({
                        url: "/cart/change.js",
                        data: {
                            quantity: 0,
                            id: mpl_administrative_cost_varriant_id
                        },
                        dataType: "json",
                        success: function () {
                            $('[data-variant-id=' + mpl_administrative_cost_varriant_id + ']').remove();
                        }
                    });
                }
            });
        }
    });
});

const select = document.getElementsByClassName('jdgm-rev-widg__body');

const config = {attributes: false, childList: true, subtree: true};
const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {

        for (let added_node of mutation.addedNodes) {
            let current = $(added_node);

            if (current.hasClass('jdgm-rev-widg__reviews')) {
                $.each($('.jdgm-rev'), function () {
                    moveJudgmeAction($(this));
                    removeEmptyReply($(this));
                    changeRatingPosition($(this));
                })
            }

            if (current.hasClass('jdgm-paginate')) {
                renderPaginationArrows();
                renderVisibleReviewCount();
                $(document).trigger('judgeme-render');
            }
        }
    }

});

$.each(select, function () {
    observer.observe(this, config);
})

function moveJudgmeAction(current_review) {
    let actions_div = current_review.find('.jdgm-rev__actions');
    let content_div = current_review.find('.jdgm-rev__content');
    content_div.append(actions_div);
}

function removeEmptyReply(current_review) {
    let reply = current_review.find('.jdgm-rev__reply');

    if (reply.html().trim() === '') {
        reply.css('display', 'none');
    }
}

function changeRatingPosition(current_review) {
    let rating = current_review.find('.jdgm-rev__rating');
    let name = current_review.find('.jdgm-rev__author-wrapper');

    name.after(rating);
}

function renderPaginationArrows() {
    let judgme_next = $('.jdgm-paginate__next-page');
    let judgme_prev = $('.jdgm-paginate__prev-page');
    let prev_icon = '<img src="//baotechusa.com/cdn/shop/t/7/assets/pagination-next.svg?v=50524247173826332981601624766" class="icon-left-open-big" alt="vorige">';
    let next_icon = '<img src="//baotechusa.com/cdn/shop/t/7/assets/pagination-next.svg?v=50524247173826332981601624766" class="icon-left-open-big" alt="nächste">';

    judgme_prev.html(prev_icon);
    judgme_next.html(next_icon);
}

function renderVisibleReviewCount() {
    let $sort_wrapper = $('.jdgm-rev-widg__sort-wrapper');
    let visible_review_count_class = 'jdgm-visible-review-count';
    let $visible_review_count = $('.' + visible_review_count_class);
    let review_translation = 'Bewertungen';
    let visible_count = $('.jdgm-rev').length;
    let all_reviews = $('.jdgm-rev-widg').data('number-of-reviews');
    let visible_review_count_text = `${visible_count} / ${all_reviews} ${review_translation}`;

    if ($visible_review_count.length) {
        $visible_review_count.text(visible_review_count_text);
    } else {
        let visible_review_count_span = `<span class="${visible_review_count_class}">${visible_review_count_text}</span>`;
        $sort_wrapper.prepend(visible_review_count_span);
    }
}

function showSmallCart(callback = null) {
    positionSmallCart()
    $(".cart__hover").stop().css("display", "flex").hide().fadeIn();

    setTimeout(function () {
        $(".cart__hover").stop().fadeOut(400, function () {
            if (callback != null) {
                callback();
            }
        });

    }, 3000);
}

function renderSmallCartIcon(items) {
    let $cart_icon_div_container = $('.cart__href');
    let $cart_count = $cart_icon_div_container.find('.site-header-cart-button__number');

    let items_qty = 0;

    $.each(items, function () {
        items_qty += this.itemQty;
    })

    $cart_icon_div_container.parent().css('display', 'flex');
    $cart_icon_div_container.parent().css('justifyContent', 'center');

    $cart_count.text(items_qty === 0 ? '' : items_qty);
}

function cartIconHaveItemsHTML(quantity) {
    let $icon_div = '<span class="icon-fallback-text">' +
        '<div class="site-header-cart-button">' +
        '<span id="CartCount" class="site-header-cart-button__number">'+quantity+'</span>' +
        '<div class="site-header__icon js-drawer-open-right" aria-controls="CartDrawer" aria-expanded="false" style="cursor: pointer;">' +
        '<img src="//baotechusa.com/cdn/shop/t/7/assets/item-in-cart.svg?v=158262501446205109511601624796" alt="Cart">' +
        '</div>' +
        '</div>' +
        '</span>';

    return $icon_div;
}

function cartIconNoItemsHtml() {
    let $icon_div = '<div class="nav-icon">' +
        '<img src="//baotechusa.com/cdn/shop/t/7/assets/cart-shallow.svg?v=82810669192196688691601624823" alt="Cart">' +
        '</div>';

    return $icon_div;
}

function activateTab(href) {
    href = href.replace('/', '');
    if (href && href.charAt(0) !== '#') {
        href = '#' + href;
    }

    var $btn = $('#home-tab-first button.home-tab[data-target="' + href + '"]');
    if (!$btn.length) {
        $btn = $('#home-tab-first button.home-tab[data-target="' + href.replace('#', '') + '"]');
    }
    $btn.triggerAll('click touchend');
}

function scrollToTabs() {
    location.href = '/#home-tab-first';
}

function positionSmallCart() {
    var $smallCart = $('.cart__hover');

    if ($smallCart.length) {
        var scrollY = window.scrollY;
        var breakpointY = 60;
        var onTopOfPage = scrollY <= breakpointY;
        var onTopClass = 'cart__hover--moved';

        if (onTopOfPage) {
            $smallCart.addClass(onTopClass);
        } else {
            $smallCart.removeClass(onTopClass)
        }
    }
}

var pagination_config = {
    collection: {
        pagination_selector: '.pagination',
        page_selector: '.page',
        current_class: 'current',
        type: 'collection'
    },
    result_page: {
        pagination_selector: '.ais-pagination',
        page_selector: '.ais-pagination--item__page',
        current_class: 'ais-pagination--item__active',
        type: 'algolia'
    },
    judgeme: {
        pagination_selector: '.jdgm-paginate',
        page_selector: '.jdgm-paginate__page:not(.jdgm-paginate__first-page):not(.jdgm-paginate__prev-page):not(.jdgm-paginate__next-page):not(.jdgm-paginate__last-page)',
        current_class: 'jdgm-curt',
        type: 'judgeme'
    }
}

jQuery.fn.hideOnSmall = function() {
    $(this).addClass('small--hide');

    return this;
};

function shrinkMobilePagination(options) {
    var $pagination = $(options.pagination_selector);

    if ($pagination.length) {
        var $pages = $pagination.children(options.page_selector);
        var current_index = 0;

        $pages.each(function(index) {
            $(this).removeClass('small--hide');

            if ($(this).hasClass(options.current_class)) {
                current_index = index;
            }
        });

        var current_in_middle = current_index == 2;
        var max_pages_count = 3;
        var pages_to_hide_count = Math.max(0, $pages.length - max_pages_count);

        if ($pages.length == 5 && current_in_middle) {
            hideNotNeededPaginationPages($pages, 'both', 1);
            pages_to_hide_count = 0;
        }

        if (pages_to_hide_count > 0) {
            var current_on_left_side = current_index < 2;
            var direction_from = current_on_left_side ? 'end' : 'beginning'
            hideNotNeededPaginationPages($pages, direction_from, pages_to_hide_count);
        }
    }
}

function hideNotNeededPaginationPages($pages, direction_from, n) {
    if (direction_from == 'both') {
        $pages.first().hideOnSmall();
        $pages.last().hideOnSmall();
    } else if (direction_from == 'beginning') {
        $pages.slice(0, n).hideOnSmall();
    } else if (direction_from == 'end') {
        $pages.slice(-n).hideOnSmall();
    }
}

function RefreshSmallCartPriceAndQty()
{
    if ($('.cart__hover').is(':visible')) {
        return;
    }

    updateSmallCartFromProductForm();
}

function updateSmallCartFromProductForm()
{
    if (!$('.js-qty__num').length || !$('meta[itemprop="price"]').length) {
        return;
    }

    let current_quantity = $('.js-qty__num').val();
    let product_price = $('meta[itemprop="price"]').attr('content');
    // Shopify centesítve tárolja az adatokat ezért meg kell még szorozni 100-al az "árat" hogy rendesen megkapjuk. A moneyformaton keresztül.
    let product_total_price = parseFloat(current_quantity) * parseFloat(product_price) * 100;

    $('.cart__hoover_qty').text(current_quantity);
    $('[class^="cart__hoover_price"]').text(Shopify.formatMoney(product_total_price));
}

$(window).on('scroll', positionSmallCart);

$(document).on('click', '.product-description-title__e', function() {
    let $next_description = $(this).next('.product-description-text__b');
    let $title = $(this);

    $next_description.slideToggle();
    if (!$title.hasClass('accordion--minus')) {
        $title.addClass('accordion--minus');
    } else {
        $title.removeClass('accordion--minus');
    }
});

function getShopifyCartData() {
    return new Promise((resolve, reject) =>  {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success: function(response) {
                resolve(response)
            },
            error: function(error) {
                reject(error);
            },
        })
    });
}

function updateSmallCartIcon() {
    getShopifyCartData().then((response) => {
        let cart = response;
        cart_items = [];
        $.each(cart.items, function(index, cartItem) {
            current_cart_item = {
                id: cartItem.id,
                key: cartItem.key,
                title: cartItem.title,
                line: index + 1,
                variation: cartItem.variant_title,
                itemQty: cartItem.quantity,
            };

            cart_items.push(current_cart_item);
        });
        renderSmallCartIcon(cart_items);

    }).catch(e => {
        console.log(e);
    });
}

// A .cart__hover alapból az oldal termékével renderelődik (menu.main.liquid). Ha egy másik
// termék (quick-cart) felülírja, az eredetit elmentjük, hogy a
// termékoldal saját kosárba tételekor (ajax-cart.js) vissza lehessen állítani.
let cartHooverDefaultHtml = null;

function restoreCartHooverDefault() {
    if (cartHooverDefaultHtml === null) {
        return;
    }

    $('.cart__hover').html(cartHooverDefaultHtml);
    cartHooverDefaultHtml = null;
}

function updateCartHoover(item) {
    const defaultPriceClass = 'cart__hoover_price';
    const discountedClass = 'cart__hoover_price-on-sale-price';

    if (cartHooverDefaultHtml === null) {
        cartHooverDefaultHtml = $('.cart__hover').html();
    }

    $('.cart__hover .cart__hover-product-name').html(item.title);
    $('.cart__hover .cart__hover-product img').attr('src', item.image);
    $('.cart__hover .cart__hoover_qty').html(item.qty);
    let $priceContainer = $('.cart__hover [class^="cart__hoover_price"]');
    $priceContainer.html(Shopify.formatMoney(Number(item.price)));

    if (item.isDiscountAppliable) {
        $priceContainer.addClass(discountedClass);
        $priceContainer.removeClass(defaultPriceClass);
    } else {
        $priceContainer.addClass(defaultPriceClass);
        $priceContainer.removeClass(discountedClass);
    }
}

function findElementInShadowDOM(root, selector) {
    if (!root) {
        return null;
    }

    if (root.querySelector(selector)) {
        return root.querySelector(selector);
    }

    for (const node of root.querySelectorAll('*')) {
        if (node.shadowRoot) {
            const found = findElementInShadowDOM(node.shadowRoot, selector);
            if (found) return found;
        }
    }

    return null;
}

function handleMolinChatWidget() {
    const customButton = document.querySelector('#molin-chat-custom-button');
    let isShadowRootObserved = false;

    const observer = new MutationObserver((mutations, obs) => {
        const molinWidget = document.querySelector('molin-shop-ai');
        const isWidgetAvailable = molinWidget && window.Molin;

        if (isWidgetAvailable) {
            const originalButton = findElementInShadowDOM(molinWidget.shadowRoot, 'button');

            if (!originalButton) {
                if (molinWidget.shadowRoot && !isShadowRootObserved) {
                    obs.observe(molinWidget.shadowRoot, {childList: true, subtree: true});
                    isShadowRootObserved = true;
                }
                return;
            }

            originalButton.style.display = 'none';

            if (!window.isStoreModalOpen) {
                customButton.style.display = "flex";
            }

            obs.disconnect()
        }
    });

    // Figyeli az egész body-t, hogy mikor kerül be az elem
    observer.observe(document.body, {
        childList: true,
        subtree: false
    });
}